var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD2H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.109 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #fff;\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    className: "cls-1",
    d: "M219.809,90.468a.9.9,0,1,1,.9-.9A.905.905,0,0,1,219.809,90.468Z",
    transform: "translate(-209.705 -84.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    className: "cls-2",
    d: "M8.464,82.351A8.469,8.469,0,0,1,.677,70.563L.8,70.286,12.065,81.555l-.277.118A8.415,8.415,0,0,1,8.464,82.351Z",
    transform: "translate(0 -67.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    className: "cls-3",
    d: "M4.978,18.391l1.017,2.743",
    transform: "translate(-2.481 -5.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-3",
    d: "M8.721,10.429l3.257-3.343",
    transform: "translate(-2.347 -1.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    className: "cls-3",
    d: "M14.389,4.256a2.809,2.809,0,0,1,2.831,2.776",
    transform: "translate(-4.096 -2.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    className: "cls-3",
    d: "M14.839,3.9A4.231,4.231,0,0,1,19.1,8.078",
    transform: "translate(-3.993 -3.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    className: "cls-3",
    d: "M-790.294-23914.922l-1.467,2.742",
    transform: "translate(792.733 23928.178)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2H);
export default __webpack_public_path__ + "static/media/d2h.d216b835decaf6b9000483c1cdc464e7.svg";
export { ForwardRef as ReactComponent };